module.exports = __webpack_public_path__ + "static/media/20210410_203626_685_IMG_0362.aac9be95.jpg";